module.exports = __webpack_public_path__ + "static/media/economy.676daf96.png";